<template>
  <div class="mt-5">
    <b-table :items="items" :fields="fields" small responsive>
      <template #cell()="data">
        <div v-if="data.value.price >= 0">
          {{ Number(data.value.price).toFixed(2) }} €
          <b-badge
            v-if="data.value.rate !== 0 && data.value.rate > 0"
            pill
            variant="light-success"
            class="ml-1"
          >
            +{{ data.value.rate }}%
          </b-badge>
          <b-badge
            v-if="data.value.rate !== 0 && data.value.rate < 0"
            pill
            variant="light-secondary"
            class="ml-1"
          >
            {{ data.value.rate }}%
          </b-badge>
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
    </b-table>

    <div
      class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1 mt-1"
    >
      <small></small>
      <small class="timeline-item-time text-nowrap text-muted ml-1"
        >Source: Yanport</small
      >
    </div>
  </div>
</template>

<script>
import { BTable, BBadge } from "bootstrap-vue";
import { currency, evalTrend } from "@core/utils/filter";

export default {
  components: {
    BTable,
    BBadge,
  },
  props: {
    rentTrend: {
      type: Object,
      required: true,
    },
    ventesByPeriode: {
      type: Object,
      required: true,
    },
  },
  data() {
    const items = [];

    var lastElem = null;
    var i = 1;
    this.rentTrend.data.forEach((element) => {
      if (lastElem != null) {
        items.push({
          year: element.year,
          rent_meter: {
            price: element.rent_meter,
            rate: evalTrend(element.rent_meter, lastElem.rent_meter),
          },
          rent_meter_pinel:
            this.rentTrend.data.length === i
              ? this.ventesByPeriode.pinel.rent + "€"
              : "-",
        });
      } else {
        items.push({
          year: element.year,
          rent_meter: {
            price: element.rent_meter,
            rate: 0,
          },
          rent_meter_pinel: "-",
        });
      }
      lastElem = element;
      i++;
    });

    return {
      fields: [
        {
          key: "year",
          label: "Année",
        },
        {
          key: "rent_meter",
          label: "Loyer/m² moyen",
        },
        {
          key: "rent_meter_pinel",
          label: "Loyer/m² Pinel",
        },
      ],
      items,
    };
  },
  methods: {
    currency,
    evalTrend,
  },
};
</script>
